/* Oratide Signal: subscribe / one-time picker. Loaded by blocks/oratide-signal-supply.liquid. */
(function () {
  if (window.__osgSupply2) return;
  window.__osgSupply2 = true;
  var S = (window.OratideSignal = window.OratideSignal || {});
  S.mode = null;
  S.plan = null;

  function supply() { return document.querySelector('[data-osg-supply]'); }

  function pickerInput(root, matcher) {
    var scope = root.closest('.shopify-section') || document;
    var picker = scope.querySelector('variant-picker');
    if (!picker) return null;
    var inputs = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) if (matcher(inputs[i])) return inputs[i];
    return null;
  }

  function chooseVariant(root, value, variantId) {
    var input = pickerInput(root, function (i) { return i.value === value || i.getAttribute('data-variant-id') === String(variantId); });
    if (input) { if (!input.checked) input.click(); return; }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.delete('selling_plan');
    window.location.href = url.toString();
  }

  /* Appstle's app embed keeps its own (hidden) purchase-options widget inside the
     product form, and its script rewrites the cart request to match that widget.
     So the widget is driven to match what the customer chose here: Subscribe ticks
     Appstle's subscription radio for the chosen plan, One-time ticks its one-time
     radio. Returns false when there is no Appstle widget on the page. */
  function syncAppstle() {
    var w = document.querySelector('.appstle_sub_widget');
    if (!w) return false;
    var radios = Array.prototype.slice.call(w.querySelectorAll('input[name="selling_plan"]'));
    if (!radios.length) return false;
    radios.forEach(function (i) { i.disabled = false; });
    var target = null;
    if (S.mode === 'sub') {
      target = (S.plan && w.querySelector('input[data-appstle-real-value="' + S.plan + '"]')) || w.querySelector('input[data-appstle-real-value]');
      var sel = w.querySelector('select');
      if (sel && S.plan && sel.value !== S.plan && sel.querySelector('option[value="' + S.plan + '"]')) {
        sel.value = S.plan;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      target = radios.filter(function (i) { return !i.hasAttribute('data-appstle-real-value'); })[0];
    }
    if (target && !target.checked) target.click();
    return !!target;
  }

  function apply() {
    var el = supply();
    if (!el) return;
    if (S.mode === null) S.mode = el.getAttribute('data-mode');
    if (!el.classList.contains('has-sub')) S.mode = 'once';
    if (el.getAttribute('data-mode') !== S.mode) el.setAttribute('data-mode', S.mode);
    el.querySelectorAll('[data-osg-mode-btn]').forEach(function (b) {
      var v = b.getAttribute('data-osg-mode-btn') === S.mode ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== v) b.setAttribute('aria-pressed', v);
    });
    var sel = el.querySelector('[data-osg-plan]');
    if (sel) {
      if (S.plan && sel.value !== S.plan && sel.querySelector('option[value="' + S.plan + '"]')) sel.value = S.plan;
      S.plan = sel.value;
      var opt = sel.options[sel.selectedIndex];
      var p = el.querySelector('[data-osg-sub-price]');
      var d = el.querySelector('[data-osg-sub-day]');
      /* Only write when different: the MutationObserver below would otherwise loop. */
      if (opt && p && p.textContent !== opt.getAttribute('data-price')) p.textContent = opt.getAttribute('data-price');
      if (opt && d && d.textContent !== opt.getAttribute('data-day')) d.textContent = opt.getAttribute('data-day');
    }
  }

  function selectTile(tile) {
    if (!tile || tile.disabled) return;
    var group = tile.closest('.osg-supply__tiles');
    if (group) group.querySelectorAll('.osg-tile').forEach(function (t) {
      var on = t === tile;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    chooseVariant(tile, tile.getAttribute('data-osg-value'), tile.getAttribute('data-osg-variant'));
  }

  function setMode(mode) {
    var el = supply();
    if (!el) return;
    S.mode = mode;
    apply();
    syncAppstle();
    if (mode === 'sub') {
      var one = el.getAttribute('data-one');
      var tile = el.querySelector('.osg-tile[data-osg-variant="' + one + '"]');
      if (tile && !tile.classList.contains('is-on')) selectTile(tile);
    }
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest) return;
    var mb = t.closest('[data-osg-mode-btn]');
    if (mb) { setMode(mb.getAttribute('data-osg-mode-btn')); return; }
    var tile = t.closest('[data-osg-supply] .osg-tile');
    if (tile) selectTile(tile);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('[data-osg-plan]')) { S.plan = event.target.value; apply(); syncAppstle(); }
  });

  document.addEventListener('keydown', function (event) {
    var tile = event.target.closest && event.target.closest('[data-osg-supply] .osg-tile');
    if (!tile) return;
    var step = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[event.key];
    if (!step) return;
    event.preventDefault();
    var tiles = Array.prototype.slice.call(tile.parentElement.querySelectorAll('.osg-tile:not([disabled])'));
    var next = tiles[(tiles.indexOf(tile) + step + tiles.length) % tiles.length];
    next.focus();
    selectTile(next);
  });

  /* Just before the product form submits, make the purchase type match the choice.
     With Appstle present its widget decides the plan (see syncAppstle); without it,
     a hidden selling_plan input is added in Subscribe mode and removed otherwise. */
  function syncForm(form) {
    if (!form || !form.closest || !supply()) return;
    var section = form.closest('.shopify-section');
    if (!section || !section.querySelector('[data-osg-supply]')) return;
    var own = form.querySelector('input[data-osg-sp]');
    if (syncAppstle()) { if (own) own.remove(); return; }
    if (S.mode === 'sub' && S.plan) {
      if (!own) {
        own = document.createElement('input');
        own.type = 'hidden';
        own.name = 'selling_plan';
        own.setAttribute('data-osg-sp', '');
        form.appendChild(own);
      }
      own.value = S.plan;
    } else if (own) {
      own.remove();
    }
  }
  document.addEventListener('submit', function (event) { syncForm(event.target); }, true);
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('button[type="submit"], [name="add"]');
    if (btn && btn.form) syncForm(btn.form);
  }, true);

  /* Horizon re-renders the section on every variant change; keep the chosen mode. */
  var mo = new MutationObserver(function () { apply(); });
  function watch() {
    var el = supply();
    var section = el && el.closest('.shopify-section');
    if (section) mo.observe(section, { childList: true, subtree: true });
    apply();
    syncAppstle();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  window.addEventListener('load', function () { setTimeout(syncAppstle, 300); });

  /** Used by the self-check, the fit cards and the closing offer on the same page. */
  S.selectQty = function (qty) {
    var el = supply();
    if (!el) return false;
    var tile = el.querySelector('.osg-tile[data-osg-qty="' + qty + '"]');
    if (!tile) return false;
    if (String(qty) !== '1' || !el.classList.contains('has-sub')) { S.mode = 'once'; apply(); syncAppstle(); }
    selectTile(tile);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    return true;
  };
  S.scrollToSupply = function () {
    var el = supply();
    if (!el) return false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    return true;
  };
})();